<template lang="pug">
.flexCenter
    div(v-if="!withAvatar")
        Badge(dot style="display: inline-flex" :count="badgeDotCount" v-if="isShown&&$store.getters.isGlobalMissionShown")
            Button(icon="md-bulb" type="primary" size="large" ghost shape="circle" @click="componentIsShown = true;$refs.missionModal.isOpened = true")
        Dropdown(@on-click="setGroupName" transfer v-if="$store.getters.hasMultiGroups||$store.getters.isAdmin")
            a(href="javascript:void(0)" style="font-size: 18px; color: #f8f8f9")
                | {{ $store.state.queryGroupName }}
                Icon(type="ios-arrow-down" v-if="$store.getters.hasMultiGroups||$store.getters.isAdmin")
            DropdownMenu(slot="list" v-if="$store.getters.hasMultiGroups||$store.getters.isAdmin")
                DropdownItem(
                    v-for="(groupName, index) in $store.getters.inGroupNames"
                    :key="groupName"
                    :name="groupName"
                    :selected="groupName == $store.state.queryGroupName"
                    :divided="index == 1"
                ) {{ groupName }}
        Dropdown(trigger="hover" @on-click="gotoRoute")
            a(
                href="javascript:void(0)"
                style="font-size: 18px; color: #f8f8f9"
                :alt="$store.state.userData.username"
                :title="$store.state.userData.username"
            )
                | {{ $store.state.userData.username | abbreviation }}
                Icon(type="ios-arrow-down")
            DropdownMenu(slot="list")
                DropdownItem(name="/account-info")
                    | {{ $t('main.userInfoText') }}
                DropdownItem(name="/logout" divided)
                    | {{ $t('main.logoutText') }}
        Dropdown(trigger="hover" @on-click="setLocale" transfer)
            a(href="javascript:void(0)" style="font-size: 18px; color: #f8f8f9")
                | {{ $t('main.userLang') }}
                Icon(type="ios-arrow-down")
            DropdownMenu(slot="list")
                DropdownItem(v-for="language in languageItems" :key="language.value" :name="language.value") {{ language.name }}
    div(v-else style="display: flex; align-items: center")
        Badge(dot style="display: inline-flex" :count="badgeDotCount" v-if="isShown&&$store.getters.isGlobalMissionShown")
            Button(icon="md-bulb" type="primary" size="large" ghost shape="circle" @click="componentIsShown = true;$refs.missionModal.isOpened = true")
        Dropdown(trigger="click" @on-click="gotoRoute")   
            .flexCenter
                Avatar(:src="avatarImg" size="64")
                span(style="font-size: 18px; color: #f8f8f9; margin-left: 8px; cursor: pointer") {{ $store.state.queryGroupName }} / {{ $store.state.userData.username }}
                    Icon(type="ios-arrow-down")
            
            DropdownMenu(slot="list")
                DropdownItem(name="/account-info") {{ $t('main.userInfoText') }}
                Dropdown(placement="right-start" @on-click="setLocale")
                    DropdownItem {{ $t('main.userLang') }}
                        Icon(type="ios-arrow-forward")
                    DropdownMenu(slot="list")
                        DropdownItem(v-for="language in languageItems" :key="language.value" :name="language.value") {{ language.name }}
                Dropdown(placement="right-start" @on-click="setGroupName" v-if="$store.getters.hasMultiGroups||$store.getters.isAdmin" transfer)
                    DropdownItem {{ $t('main.group') }}
                        Icon(type="ios-arrow-forward")
                    DropdownMenu(slot="list")
                        DropdownItem(v-for="(groupName,index) in $store.getters.inGroupNames" :key="groupName" :name="groupName" :selected="groupName == $store.state.queryGroupName" :divided="index == 1") {{ groupName }}
                DropdownItem(name="/logout") {{ $t('main.logoutText') }}
    MissionModal(ref="missionModal" @updateCurrentStep="updateCurrentStep($event)" v-if="componentIsShown")
</template>
<script>
import { setUserLang } from "@/api/user";
import bus from "@/libs/bus.js";

export default {
    name: "MainNav",
    components: {},
    data() {
        return {
            componentIsShown: false,
            showMissonModal: false,
            userAvatar: this.$store.state.userAvatar,
            badgeDotCount: 1,
            languageItems: [],
        };
    },
    methods: {
        gotoRoute(name) {
            if (name == "/logout" || name == "/account-info") {
                this.$router.push(name);
            }
        },
        setLocale(lang) {
            if (lang !== undefined) {
                this.$i18n.locale = lang;
                this.$store.commit("SET_USER_PREF", { lang: lang });
                let i18Title = this.$i18n.t("routesMenu." + this.$router.currentRoute.meta.title);
                document.title = `${i18Title} | ${this.$store.state.platformPrefs.brandTitle}`;
                this.$emit("changeLocale");
                //打後台api
                setUserLang({ userLang: lang })
                    .then((response) => {
                        console.log(`${response.data.message}`);
                    })
                    .catch((err) => {
                        console.log(`${err.message}`);
                    });
            }
        },
        setGroupName(groupName) {
            if (groupName !== undefined) bus.$emit("SET_QUERY_GROUPNAME", groupName);
        },
        updateCurrentStep(step) {
            this.badgeDotCount = this.$refs.missionModal.tasks.length - this.$refs.missionModal.currentStep;
        },
    },
    mounted() {
        var main = this.$i18n.t(`main.languageItem`);
        var languageItems = this.$store.state.platformPrefs.pages.InnerPage.layout.languageItems;
        var lang = languageItems.map((item) => {
            if (Object.keys(main).includes(item)) {
                return { name: this.$i18n.t(`main.${item}`), value: item };
            } else {
                return { name: item, value: item };
            }
        });
        this.languageItems = lang;
    },
    created() {},
    computed: {
        isShown() {
            if (this.$store.getters.isAdmin) {
                if (this.$store.state.queryGroupName !== "all") {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (this.$store.state.queryGroupName !== "all" && this.hasShownGlobalMissionPermission) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        hasShownGlobalMissionPermission() {
            return this.$store.getters.currentGroupRolePermissions.groupResourcesPermission
                ? this.$store.getters.currentGroupRolePermissions.groupResourcesPermission.write
                : false;
        },
        // badgeDotCount() {
        //     return this.$store.state.isGlobalMissionCompleted == true ? 0 : 1;
        // },
        avatarImg() {
            return "../../../static/avatar/" + this.userAvatar + ".svg";
        },
        withAvatar() {
            return this.$store.getters.getUserWithAvatar;
        },
        // languageItems: {
        //     get() {
        //         // return this.$store.getters.getLanguageItems;
        //         return ["en-US", "zh-TW", "zh-CN", "韓文"];
        //     },
        //     set() {}
        // }
    },
    watch: {},
    sockets: {},
    filters: {
        abbreviation: function (value) {
            let limitLength = 10;
            if (value.length <= limitLength) return value;

            let abbrevName = value;

            if (value.includes("@")) abbrevName = value.split("@")[0];
            if (abbrevName.length > 10 && abbrevName.includes(".")) {
                abbrevName = value.split(".")[0].charAt(0).toUpperCase() + value.split(".")[1].charAt(0).toUpperCase();
            }
            if (abbrevName.length > 10) abbrevName = abbrevName.charAt(0).toUpperCase() + value.slice(1, 3);

            return abbrevName;
        },
    },
};
</script>
<style>
.flexCenter {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/MainNav.vue